<template>
    <section :id="id" :class="classe">
        <header class="container-ifgo">
            <h3 :id="`${id}_`"><span class="codigo">&lt;</span>{{ titulo }} <span class="codigo">/&gt;</span></h3>
            <hr>
        </header>
        <div class="container-ifgo">
        
        <slot name="default"></slot>
        </div>
    </section>
</template>

<script>
export default ({
    props: {
        id: String,
        classe: String,
        titulo: String,
    }
});
</script>
